function mascaraMoeda(value) {
  if (!value) {
    return 0;
  }

  const onlyDigits = value
    .split("")
    .filter((s) => /\d/.test(s))
    .join("")
    .padStart(3, "0");

  const digitsFloat = onlyDigits.slice(0, -2) + "." + onlyDigits.slice(-2);

  return parseFloat(digitsFloat);
}

function maskCurrency(valor, locale = "pt-BR", currency = "BRL") {
  if (isNaN(valor)) {
    valor = 0;
  }

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  }).format(valor);
}

function removeCaracteresEspeciais(str) {
  return (
    str
      ?.normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/-/gi, "_")
      .replace(/ /gi, "_") ?? ""
  );
}

function numOrderFormat(numOrder) {
  if (numOrder === undefined || numOrder === null) return "";
  return String(numOrder).padStart(5, "0");
}

function convertValueTypeStock(type = null, value = 0) {
  if (!type) {
    return 0;
  }

  if (type === "KG") {
    return `${value} KG`;
  }

  if (type === "UN") {
    return `${value} UN`;
  }

  if (type === "LT") {
    return `${value} LT`;
  }
}

function downloadFile(url, name) {
  fetch(url)
    .then((resp) =>
      resp.status === 200
        ? resp.blob()
        : Promise.reject("something went wrong"),
    )
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      // the filename you want
      a.download = name;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    })
    .catch(() => alert("Erro ao baixar arquivo"));
}

function extractPixValue(pixCopiaCola) {
  if (typeof pixCopiaCola !== "string") return null;

  let i = 0;

  while (i < pixCopiaCola.length) {
    const id = pixCopiaCola.substring(i, i + 2);
    const length = parseInt(pixCopiaCola.substring(i + 2, i + 4), 10);
    const value = pixCopiaCola.substring(i + 4, i + 4 + length);

    // Campo 54 = valor do PIX
    if (id === "54") {
      return parseFloat(value);
    }

    i += 4 + length;
  }

  // PIX sem valor fixo
  return null;
}

const formatErrosJoi = (erros) => {
  const messages = erros?.details.map((v) => {
    return {
      [v.path]: v.message,
    };
  });

  return messages ?? null;
};

export {
  formatErrosJoi,
  mascaraMoeda,
  maskCurrency,
  removeCaracteresEspeciais,
  numOrderFormat,
  convertValueTypeStock,
  downloadFile,
  extractPixValue,
};
